import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApplicationProcess = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "applicationProcess",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17733",
		"data-name": "Group 17733",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13125",
				"data-name": "Path 13125",
				d: "M7.554,11H4A2,2,0,0,1,2,9V4A2,2,0,0,1,4,2H20a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H10.554",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13126",
				"data-name": "Path 13126",
				d: "M10.554,13V8.5A1.5,1.5,0,0,0,9.054,7h0a1.5,1.5,0,0,0-1.5,1.5V16l-.9-.9a1.554,1.554,0,0,0-2.2,0h0a1.554,1.554,0,0,0-.194,1.961l2.7,4.049A2,2,0,0,0,8.625,22h5.288A2,2,0,0,0,15.9,20.248l.542-4.337a2,2,0,0,0-1.662-2.222L10.554,13Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13127",
				"data-name": "Path 13127",
				d: "M18.5,5.5,16,8,14.5,6.5",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13128",
		"data-name": "Path 13128",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgApplicationProcess;
